// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_FDzng","loginById":"index_loginById_aIqyT","active":"index_active_p3Neg"};